/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ChildrensInputs */

const en_childrens = /** @type {(inputs: ChildrensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Children's`)
};

const es_childrens = /** @type {(inputs: ChildrensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infantil`)
};

const fr_childrens = /** @type {(inputs: ChildrensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enfants`)
};

const de_childrens = /** @type {(inputs: ChildrensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinder`)
};

const ja_childrens = /** @type {(inputs: ChildrensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`子供`)
};

const zh_childrens = /** @type {(inputs: ChildrensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儿童`)
};

const ar_childrens = /** @type {(inputs: ChildrensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أطفال`)
};

const id_childrens = /** @type {(inputs: ChildrensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anak-anak`)
};

const it_childrens = /** @type {(inputs: ChildrensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bambini`)
};

const ru_childrens = /** @type {(inputs: ChildrensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детские`)
};

const pt_childrens = /** @type {(inputs: ChildrensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infantil`)
};

const ko_childrens = /** @type {(inputs: ChildrensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어린이`)
};

/**
* | output |
* | --- |
* | "Children's" |
*
* @param {ChildrensInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const childrens = /** @type {((inputs?: ChildrensInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ChildrensInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_childrens(inputs)
	if (locale === "es") return es_childrens(inputs)
	if (locale === "fr") return fr_childrens(inputs)
	if (locale === "de") return de_childrens(inputs)
	if (locale === "ja") return ja_childrens(inputs)
	if (locale === "zh") return zh_childrens(inputs)
	if (locale === "ar") return ar_childrens(inputs)
	if (locale === "id") return id_childrens(inputs)
	if (locale === "it") return it_childrens(inputs)
	if (locale === "ru") return ru_childrens(inputs)
	if (locale === "pt") return pt_childrens(inputs)
	return ko_childrens(inputs)
});